/**
 * LoadingSpinner Component
 *
 * Simple loading spinner for Suspense fallbacks during route transitions.
 * Respects prefers-reduced-motion for accessibility.
 */

import { useEffect, useState } from 'react';
import './LoadingSpinner.css';
import { t } from '../i18n';

export function LoadingSpinner() {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    return false;
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const handleChange = (e: MediaQueryListEvent) => {
      setPrefersReducedMotion(e.matches);
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return (
    <div
      className="loading-spinner-container"
      role="status"
      aria-label={t('loading.default')}
    >
      <div
        className={`loading-spinner ${prefersReducedMotion ? 'reduced-motion' : ''}`}
        aria-hidden="true"
      />
      <span className="sr-only">{t('loading.default')}</span>
    </div>
  );
}
